import { useEffect } from 'react';
import { signOut } from 'firebase/auth';
import { auth, registrarActividad } from '../firebase';

// Cierre de sesión diario a las 23:59 en todas las computadoras (pedido de
// Mica, 2026-10-26): por seguridad, y para que al día siguiente cada una
// vuelva a entrar y vea su saludo de bienvenida.
// Se compara contra la hora del último inicio de sesión que guarda Firebase,
// así también cierra si la compu estaba apagada o la pestaña cerrada a esa hora.
const HORA = 23;
const MINUTO = 59;

// Las 23:59 más recientes que ya pasaron.
function ultimoCorte(ahora = new Date()) {
  const corte = new Date(ahora);
  corte.setHours(HORA, MINUTO, 0, 0);
  if (corte > ahora) corte.setDate(corte.getDate() - 1);
  return corte;
}

export default function useCierreDiario(usuario) {
  useEffect(() => {
    if (!usuario) return undefined;
    let cerrando = false;
    const revisar = async () => {
      if (cerrando) return;
      const inicio = Date.parse(auth.currentUser?.metadata?.lastSignInTime || '');
      if (!inicio || inicio >= ultimoCorte().getTime()) return;
      cerrando = true;
      await registrarActividad('Cierre de sesión automático (23:59)').catch(() => {});
      await signOut(auth);
    };
    revisar();
    const intervalo = setInterval(revisar, 30 * 1000);
    const alVolver = () => { if (document.visibilityState === 'visible') revisar(); };
    document.addEventListener('visibilitychange', alVolver);
    window.addEventListener('focus', revisar);
    return () => {
      clearInterval(intervalo);
      document.removeEventListener('visibilitychange', alVolver);
      window.removeEventListener('focus', revisar);
    };
  }, [usuario]);
}
